import { siteConfig } from '@/configs/siteConfig';

import { siteState } from '@/modules/siteState/siteStateGetter';
import { smoothScroll } from '@/modules/smoothScroll';

const smoothClassName = smoothScroll.getTriggerClassName();

const props = {
  className: 'js-accordion',
  classNameOsc: 'js-accordionOsc',
  classNameShift: 'js-accordionShift',
  classNameRemove: 'js-accordionRemove',
  duration: 400,
} as const;

const state = {};

export const accordionManager = {
  init() {
    this.setupClick();
    this.setupClickOsc();
    this.setupClickShift();
    this.setupClickRemove();
  },

  setupClick() {
    const els = Array.from(document.querySelectorAll(`.${props.className}`)) as HTMLElement[];
    els.forEach((el: HTMLElement) => {
      el.addEventListener(
        'click',
        (e) => {
          const clickSelector = el.dataset.click;
          if (clickSelector) {
            const targetEl = document.querySelector(clickSelector) as HTMLElement | null;
            if (targetEl) {
              targetEl.click();
              e.preventDefault();
              return;
            }
          }

          if (el?.classList.contains(smoothClassName)) {
            smoothScroll.disableOnce();
          }

          const next = el.nextElementSibling as HTMLElement | null;
          if (next) {
            if (el.classList.contains(siteConfig.class.act)) {
              el.classList.remove(siteConfig.class.act);
              this.slideUp(next);
            } else {
              el.classList.add(siteConfig.class.act);
              this.slideDown(next);
            }
          }
          e.preventDefault();
        },
        { capture: true },
      );
    });
  },

  setupClickOsc() {
    const els = Array.from(document.querySelectorAll(`.${props.classNameOsc}`)) as HTMLElement[];
    els.forEach((el: HTMLElement) => {
      el.addEventListener(
        'click',
        (e) => {
          const clickSelector = el.getAttribute('href');
          if (clickSelector) {
            const targetEl = document.querySelector(clickSelector) as HTMLElement | null;
            if (targetEl) {
              const next = targetEl.nextElementSibling as HTMLElement | null;
              if (next) {
                if (!targetEl.classList.contains(siteConfig.class.act)) {
                  targetEl.classList.add(siteConfig.class.act);
                  this.slideDown(next);
                }
              }
              e.preventDefault();
              return;
            }
          }
        },
        { capture: true },
      );
    });
  },

  setupClickShift() {
    const shiftEls = Array.from(document.querySelectorAll(`.${props.classNameShift}`)) as HTMLElement[];
    shiftEls.forEach((el) => {
      el.addEventListener(
        'click',
        (e) => {
          if (siteState.winWidth < siteConfig.breakpoint.shiftPoint) {
            if (el?.classList.contains(smoothClassName)) {
              smoothScroll.disableOnce();
            }

            const next = el.nextElementSibling as HTMLElement | null;
            if (next) {
              if (el.classList.contains(siteConfig.class.act)) {
                el.classList.remove(siteConfig.class.act);
                this.slideUp(next);
              } else {
                el.classList.add(siteConfig.class.act);
                this.slideDown(next);
              }
            }
            e.preventDefault();
          }
        },
        { capture: true },
      );
    });
  },

  setupClickRemove() {
    const shiftEls = Array.from(document.querySelectorAll(`.${props.classNameRemove}`)) as HTMLElement[];
    shiftEls.forEach((el) => {
      el.addEventListener(
        'click',
        (e) => {
          const next = el.nextElementSibling as HTMLElement | null;
          if (next) {
            el.remove();
            next.classList.add(siteConfig.class.act);
            this.slideDown(next);
          }
          e.preventDefault();
        },
        { capture: true },
      );
    });
  },

  slideUp(el: HTMLElement) {
    el.style.transition = `height ${props.duration}ms`;
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    requestAnimationFrame(() => {
      el.style.height = '0';
    });
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, props.duration);
  },

  slideDown(el: HTMLElement) {
    const hasDataHeight = el.dataset.height !== undefined;
    const styleHeight = hasDataHeight ? getComputedStyle(el).height : '0';

    el.style.display = 'block';
    el.style.height = 'auto';
    const height = el.offsetHeight;

    el.style.height = styleHeight;
    el.style.overflow = 'hidden';
    el.style.transition = `height ${props.duration}ms`;

    requestAnimationFrame(() => {
      el.style.height = height + 'px';
    });

    setTimeout(() => {
      if (hasDataHeight) {
        el.style.height = 'auto';
      } else {
        el.style.removeProperty('height');
      }
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, props.duration);
  },
};
